import 'tooltipster';
import { useState, useEffect } from "react";
import { tv } from "../../lib/api/api";
import { Link } from 'react-router-dom';

const ChannelTooltip = ({channel_id, tariffs}) => {
    const [info, setInfo] = useState({});
    const [image, setImage] = useState('');
    const [description, setDescription] = useState('');
    const [basicPackages, setBasicPackages] = useState([]);

    useEffect(() => {
        tv.channel(channel_id)
            .then((res) => {
                setInfo(res);
                const packages = [];
                res.tariffs.forEach(item => {
                    tariffs.forEach(elem => {
                        if (elem.id === item && elem.weight > 0 && elem.offer === 1 && elem.is_hd) {
                            packages.push(elem);
                        }
                    });
                });
                setBasicPackages(packages);
                setDescription(res.description.slice(0, res.description.indexOf('.') + 1));
                if (res.media.default) {
                    setImage(res.media.default.url);
                } else if (res.media.large) {
                    setImage(res.media.large.url);
                } else if (res.media.medium) {
                    setImage(res.media.medium.url);
                } else if (res.media.small) {
                    setImage(res.media.small.url);
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }, []);

    return (
        <>
            <div className="tv-program__channel-tooltip">
                <div className="tv-program-popover">
                    <div className="tv-program-popover__image">
                        <img src={image} width="220" height="220"/>
                    </div>
                    <div className="tv-program-popover__info">
                        <h4 className="tv-program-popover__title">{info.name}</h4>
                        <div className="tv-program-popover__description"><p>{description}</p></div>
                        {basicPackages.length > 0 ? (
                            <div className="tv-program-popover__packages-wrapper">
                                <div className="tv-program-popover__package">
                                    <p className="tv-program-popover__package-title">В составе основных пакетов</p>
                                    <ul className="tv-program-popover__package-list">
                                        {basicPackages.map(item => (
                                            <li className="tv-program-popover__package-list-item">
                                                <Link className="tv-program-popover__package-link" to={`//telekarta.tv/packages/?tariff=${item.name === 'Пионер' ? 2 : item.name === 'Мастер' ? 4 : item.name === 'Лидер' ? 5 : 7}#tariffs`}>{item.name}</Link>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        ) : ''}
                    </div>
                </div>
            </div>
        </>
    );
};

export default ChannelTooltip;
